"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentCreateFormPurposesEnum = exports.AttachmentCreateFormToJSON = exports.AttachmentCreateFormFromJSONTyped = exports.AttachmentCreateFormFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function AttachmentCreateFormFromJSON(json) {
    return AttachmentCreateFormFromJSONTyped(json, false);
}
exports.AttachmentCreateFormFromJSON = AttachmentCreateFormFromJSON;
function AttachmentCreateFormFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'file': json['file'],
        'fileName': !runtime_1.exists(json, 'fileName') ? undefined : json['fileName'],
        'side': !runtime_1.exists(json, 'side') ? undefined : _1.AttachmentSideModelFromJSON(json['side']),
        'type': !runtime_1.exists(json, 'type') ? undefined : json['type'],
        'purposes': json['purposes'],
    };
}
exports.AttachmentCreateFormFromJSONTyped = AttachmentCreateFormFromJSONTyped;
function AttachmentCreateFormToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'file': value.file,
        'fileName': value.fileName,
        'side': _1.AttachmentSideModelToJSON(value.side),
        'type': value.type,
        'purposes': value.purposes,
    };
}
exports.AttachmentCreateFormToJSON = AttachmentCreateFormToJSON;
/**
* @export
* @enum {string}
*/
var AttachmentCreateFormPurposesEnum;
(function (AttachmentCreateFormPurposesEnum) {
    AttachmentCreateFormPurposesEnum["FACIALIDENTIFICATION"] = "FACIAL_IDENTIFICATION";
    AttachmentCreateFormPurposesEnum["FINGERPRINTIDENTIFICATION"] = "FINGERPRINT_IDENTIFICATION";
    AttachmentCreateFormPurposesEnum["CITIZENSHIP"] = "CITIZENSHIP";
    AttachmentCreateFormPurposesEnum["NAMELINKING"] = "NAME_LINKING";
    AttachmentCreateFormPurposesEnum["PHOTOID"] = "PHOTO_ID";
})(AttachmentCreateFormPurposesEnum = exports.AttachmentCreateFormPurposesEnum || (exports.AttachmentCreateFormPurposesEnum = {}));
//# sourceMappingURL=AttachmentCreateForm.js.map